import React from 'react'

const GlyphSmallCancel = props => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M63.79 63.2l-3.88 3.88-9.71-9.7-9.7 9.7-3.88-3.88 9.7-9.71-9.7-9.7 3.88-3.88 9.7 9.7 9.71-9.7 3.88 3.88-9.7 9.7 9.7 9.71z' />
  </svg>
)

export default GlyphSmallCancel
